import Client from "../client/Base"
const resource = "/api/v2"

const getLiveScores = (params) => {
  return Client.get(`${resource}/publish/livescore/`, { params })
}

const getCategories = (params) => {
  return Client.get(`${resource}/publish/categories/`, { params })
}

const getSubjects = (params) => {
  return Client.get(`${resource}/publish/categories/type/`, { params })
}

const userRepository = {
  getLiveScores,
  getCategories,
  getSubjects
}
export default userRepository
